import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
const containerCss = "c1mx1jg5";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledErrorMessageCss = "s1hy4txa";
const StyledErrorMessage = forwardRef((props, ref) => <ErrorMessage ref={ref} {...props} className={classNames(styledErrorMessageCss, props.className)} />);
export const WarningMessage = ({
  message
}) => <Container>
    <AlertWarningTriangleIcon />
    <StyledErrorMessage message={message} />
  </Container>;

require("./warning_message.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./warning_message.js");